/* @flow */

import React from 'react';
import Relay from 'react-relay';

import KeywordToken from './KeywordToken';
import MentionToken from './MentionToken';
import TextToken from './TextToken';

const TOKEN_MAP = {
  mention: MentionToken,
  keyword: KeywordToken,
  link: TextToken,
  text: TextToken,
};

type Token = {
  type: string,
  source: string,
};

type Props = {
  tokens: Array<Token>,
};

const filterEmpty = text => text.trim();
const addBreaks = text => {
  const hasNewLines = /\n/.test(text);
  const appendBreak = (item, key) => (<span key={key}>{item}<br/></span>);

  return hasNewLines ? text.split('\n').map(appendBreak) : text;
};

const UserText = ({tokens, withBreaks}: Props) =>
  <span>
    {tokens.map((token, index) => {
      const TokenComponent = TOKEN_MAP[token.type];
      const tokenText = (withBreaks && (token.type === 'text') && token.source) ? addBreaks(token.source) : token.source;

      return <TokenComponent key={index} source={tokenText} />;
    })}
  </span>;


export default Relay.createContainer(UserText, {
  fragments: {
    tokens: () => Relay.QL`
      fragment on UserTextToken @relay(plural: true) {
        type
        source
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/UserText/index.js